export const toKebabCase = (str: string) =>
  str
    .normalize("NFD") // Normalize to decomposed form for handling accents
    .replace(/[\u0300-\u036f]/g, "") // Remove diacritics/accents
    .toLowerCase() // Convert to lowercase
    .replace(/[^\w\s-]/g, "-") // Remove special characters except spaces, hyphens, and underscores
    .replace(/[\s_]+/g, "-") // Replace spaces and underscores with hyphens
    .replace(/-+/g, "-") // Replace multiple hyphens with a single hyphen
    .replace(/^-+|-+$/g, ""); // Remove leading and trailing hyphens
